import React from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

/**
 * Hook für das automatische Zoomen auf das Polygon (nur beim ersten Laden)
 */
export const useAutoZoomToPolygon = (
  flaeche: [number, number][], 
  anlagen: [number, number][]
) => {
  const map = useMap();
  const hasInitialized = React.useRef(false);
  
  React.useEffect(() => {
    // Nur beim ersten Laden der Karte zoomen, nicht bei Layer-Änderungen
    if (hasInitialized.current) return;
    
    // Kurze Verzögerung, um sicherzustellen, dass die Karte vollständig initialisiert ist
    const timer = setTimeout(() => {
      if (map && (flaeche.length > 0 || anlagen.length > 0)) {
        try {
          const coordinates = flaeche.length > 0 ? flaeche : anlagen;
          
          if (coordinates.length > 0) {
            // Erstelle Bounds aus den Koordinaten
            const bounds = L.latLngBounds(coordinates);
            
            // Füge etwas Padding hinzu, damit das Polygon nicht am Rand liegt
            map.fitBounds(bounds, {
              padding: [20, 20], // 20px Padding oben/unten und links/rechts
              maxZoom: 18, // Maximaler Zoom-Level
              animate: true
            });
            
            // Markiere als initialisiert
            hasInitialized.current = true;
          }
        } catch (error) {
        }
      }
    }, 100); // 100ms Verzögerung
    
    return () => {
      clearTimeout(timer);
    };
  }, [flaeche, anlagen, map]);
};
